function mapTranslatedOptions(originalOptions, translatedOptions) {
  const translatedMap = new Map((translatedOptions || []).map((opt) => [String(opt.key), String(opt.text || '')]));

  if (Array.isArray(originalOptions)) {
    return originalOptions.map((opt) => ({
      ...opt,
      text: translatedMap.get(String(opt.key)) || opt.text
    }));
  }

  const result = {};
  Object.entries(originalOptions || {}).forEach(([key, text]) => {
    result[key] = translatedMap.get(String(key)) || text;
  });
  return result;
}

export function buildDisplayQuestion(question, translatedContent) {
  if (!question || !translatedContent) return question;

  const next = { ...question };
  if (typeof question.scenario === 'string' && translatedContent.scenario) {
    next.scenario = translatedContent.scenario;
  }
  if (typeof question.question === 'string' && translatedContent.questionText) {
    next.question = translatedContent.questionText;
  }
  if (question.options) {
    next.options = mapTranslatedOptions(question.options, translatedContent.options || []);
  }
  return next;
}

export function translatedBadge(currentLanguage, label = 'Translated') {
  if (currentLanguage === 'en') return null;
  return {
    show: true,
    label
  };
}
